/**
 * Short attention-getting chime, synthesized via the Web Audio API (no
 * audio file asset needed). Shared by the notification bell
 * (NotificationBellWidget.tsx) and the chat-offer popup (ChatOfferPopup.tsx)
 * — both want the same "something needs your attention" sound rather than
 * two near-identical inline implementations.
 */
export function playNotificationChime(): void {
  try {
    const ctx = new AudioContext()
    const oscillator = ctx.createOscillator()
    const gain = ctx.createGain()
    oscillator.type = 'sine'
    oscillator.frequency.setValueAtTime(880, ctx.currentTime)
    gain.gain.setValueAtTime(0.15, ctx.currentTime)
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.3)
    oscillator.connect(gain)
    gain.connect(ctx.destination)
    oscillator.start()
    oscillator.stop(ctx.currentTime + 0.3)
  } catch {
    // Audio playback can fail silently (autoplay policy, no audio device) —
    // never let a chime failure break the notification flow.
  }
}
